import styled from "styled-components";
import { Button } from "react-bootstrap";

export const ThemedButton = styled(Button)`
  background-color: ${(props) => props.backgroundColor || "#ff3f6c"};
  font-weight: ${(props) => props.fontWeight || 600};
  color: ${(props) => props.color || "#fff"};
  border: 0;

  &:hover {
    background-color: ${(props) => props.hoverColor || "#ff0c45"};
  }

  &:disabled {
    background-color: grey !important;
  }
`;
